import { render } from "./ListLayout.vue?vue&type=template&id=1740fde9"
import script from "./ListLayout.vue?vue&type=script&lang=js"
export * from "./ListLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__